<div class="w-full gap-20 flex flex-col">
  <div class="flex items-center justify-center">
    <span
      class="text-primary text-2xl border-[2px] border-transparent border-b-primary p-4"
    >
      Forgot Password</span
    >
  </div>
  <form [formGroup]="authForm" class="flex flex-col gap-6">
    <div class="w-full">
      <span> Enter Email</span>
      <input
        placeholder="Enter your email address"
        class="w-full border p-2 rounded-md outline-none"
        formControlName="email"
      />
      <div
        *ngIf="authForm.controls['email'].errors?.['email']"
        class="text-red-500"
      >
        Invalid Email Address
      </div>
    </div>

    <div class="items-center justify-center flex">
      <!-- routerLink="/reset-password" -->
      <button
        class="text-white p-2 px-6 rounded-xl"
       
        [ngStyle]="{
          backgroundColor: authForm.controls['email'].valid
            ? 'var(--primary)'
            : 'gray'
        }" (click)="forgetPassword()"
      >
        Get Reset Link
      </button>
    </div>
  </form>
</div>
